export default __webpack_public_path__ + "static/media/tfd-logo-1.6850c657.png";